import { TranslationKey } from '@hermes/translations'
import { BookConditions, BookConditionsEnum } from '@hermes/types'

export const conditionsDataToPoEditorMapper = (data: BookConditions): TranslationKey => {
  const POEditorMapping = {
    [BookConditionsEnum.NEW]: 'common.new',
    [BookConditionsEnum.LIKE_NEW]: 'common.like_new',
    [BookConditionsEnum.VERY_GOOD]: 'common.very_good',
    [BookConditionsEnum.GOOD]: 'common.good',
    [BookConditionsEnum.ACCEPTABLE]: 'common.acceptable',
    [BookConditionsEnum.REFURBISHED]: 'common.refurbished'
  } as const

  return POEditorMapping[data]
}
